const JiaShuJu = {
   ctx: null,
  _data: null,

  init(ctx) {
    this.ctx = ctx;
    this._data = this.getData()
  },

  //设置位置
  _locInit: false,
  onLocationInit(){
    // if(this._locInit){
    //   return ;
    // }
    this._locInit = true;
    for(const item of this._data.packet){
      item.lat = this.ctx.$info.location.lat + this.getRandomLocation()
      item.lng = this.ctx.$info.location.lng + this.getRandomLocation()
    }
    for(const item of this._data.wish){
      item.lat = this.ctx.$info.location.lat + this.getRandomLocation()
      item.lng = this.ctx.$info.location.lng + this.getRandomLocation()
    }
    for(const item of this._data.free){
      item.lat = this.ctx.$info.location.lat + this.getRandomLocation()
      item.lng = this.ctx.$info.location.lng + this.getRandomLocation()
    }
    for(const item of this._data.nearby){
      item.lat = this.ctx.$info.location.lat + this.getRandomLocation()
      item.lng = this.ctx.$info.location.lng + this.getRandomLocation()
    }
  },

  //获取红包
  getRedPacket(){
    this.onLocationInit()
    return this._data.packet
  },

  removeRedPacket(id){
    for(let i=0; i<this._data.packet.length; i++){
      let item = this._data.packet[i]

      if(id == item.id){
        this._data.packet.splice(i, 1)
        break;
      }
    }
    this.saveData()
  },

  //获取清单
  getWish(){
    this.onLocationInit()
    return this._data.wish
  },

  removeWish(id){
    for(let i=0; i<this._data.wish.length; i++){
      let item = this._data.wish[i]

      if(id == item.id){
        this._data.wish.splice(i, 1)
        break;
      }
    }

    this.saveData()
  },

  //获取无偿
  getFree(){
    this.onLocationInit()
    return this._data.free
  },
  removeFree(id){
    for(let i=0; i<this._data.free.length; i++){
      let item = this._data.free[i]

      if(id == item.id){
        this._data.free.splice(i, 1)
        break;
      }
    }
    this.saveData()
  },

  //获取附近的人
  getNearby(){
    this.onLocationInit()

    return this._data.nearby
  },

  saveData(){
    try{
      localStorage["jiashuju"] = JSON.stringify(this._data);
    }catch (e) {
      console.error(e)
    }
  },

  _msgRecvHandler: null,
  setMsgRecvHandler(handler){
    this._msgRecvHandler = handler
  },

  addDialog(id, sender, context){
    let item = {}
    item["group"] = id
    item["msgno"] = new Date().getTime();
    item["time"] = new Date().toDateString();
    item["sender"] = sender
    item["type"] = 0
    item["context"] = context
    item["off"] = false

    item["owner"] = item["group"]

    console.log(' xxx   ', item)
    try{
      if(this._msgRecvHandler){
        this._msgRecvHandler(item)
      }
    }catch (e) {
      this.ctx.$logger.error(e)
    }
    this.ctx.$websql.addGroupChatMsg(item)
  },


  getData(){
    try {
      let data = localStorage["jiashuju"];
      if (data != null && data.length > 0) {
        return JSON.parse(data)
      }
    } catch (err) {
      console.log(err)
    }
    return {
      packet: [
        {"id":"4756299603639275520","lng":114.02597366,"lat":22.54605355},
        {"id":"4756300545466044416","lng":114.02597366,"lat":22.54605355},
      ],
      wish: [
        {"id":"4756265555818725376","lng":114.02597366,"lat":22.54605355,"bizType":2},
        {"id":"4756282937685590016","lng":114.02597366,"lat":22.54605355,"bizType":2},
        {"id":"4756285998596374528","lng":114.02597366,"lat":22.54605355,"bizType":2},
        // {"id":"4754838811165343744","lng":114.02597366,"lat":22.54605355,"bizType":2},
        // {"id":"4754861878256091136","lng":114.02597366,"lat":22.54605355,"bizType":2},
      ],
      free: [
        {"id":"4756269705369501696","lng":114.02532142,"lat":22.54627086,"bizType":3},
        {"id":"4756270324624932864","lng":114.02532142,"lat":22.54627086,"bizType":3},
        {"id":"4756274389413019648","lng":114.02532142,"lat":22.54627086,"bizType":3},
        {"id":"4756282937685590016","lng":114.02532142,"lat":22.54627086,"bizType":3},
        {"id":"4756275134615011328","lng":114.02532142,"lat":22.54627086,"bizType":3},
      ],

      nearby: [
        // {id: 4748687269974507520, userNo: 11909472, "lng":116.40400894,"lat":39.91759174, nickname: '美食众享', sign:'不一样的吃货',  head: 'group1/M00/00/10/rBKvFVv_sWOEGVhcAAAAAEtxoUY2829480', audio: './user_audio1.mp3'},
        {id: "4748687269973507520", userNo: 11909472, "lng":116.40400894,"lat":39.91759174, nickname: '美食众享', sign:'不一样的吃货',  head: './user_head1.jpg', audio: './user_audio1.mp3'},
        {id: "4707524868726997451", userNo: 11909473, "lng":116.40400894,"lat":39.91759174, nickname: '美食众享', sign:'不一样的吃货',  head: './user_head2.jpg', video: './user_video2.mp4'},
        {id: "4747522868726997450", userNo: 11909474, "lng":116.40400894,"lat":39.91759174, nickname: '美食众享', sign:'不一样的吃货',  head: './user_head3.jpg', video: './user_video3.mp4'},
        {id: "4753977294295452655", userNo: 14839845, "lng":116.40400894,"lat":39.91759174, nickname: '我爱运动', sign:'夜跑-跑出我的人生', head: './user_head4.jpg', video: './user_video4.mp4'},
        {id: "4752942954526539776", userNo: 14839847, "lng":116.40400894,"lat":39.91759174, nickname: '我爱运动', sign:'夜跑-跑出我的人生', head: './user_head5.jpg', audio: './user_audio2.mp3'},
        ]
    };
  },

  getRandomLocation() {
    return (Math.random() * 12 - 6) / 1000 + ((Math.random()>=0.5?1:-1) * (Math.random() * 30) / 2500);
  },
  //4766414729243541504
  jiaDialog1: [
    {sender: 4754815493586550784, context: '请问小竹童鞋,在不在?'},
    {sender: 4755869713303601152, context: '在的.'},
    {sender: 4754815493586550784, context: '我来问问,就是我牙疼,到你们社区大概要多少费用啊'},
    {sender: 4755869713303601152, context: '亲,这个牙疼具体要看是什么病症.'},
    {sender: 4755869713303601152, context: '您这样说,小竹很难确诊啊,要不您来一下,位置距离您不远的.'},
    {sender: 4754815493586550784, context: '额,好吧.'},
    {sender: 4754815493586550784, context: '不过我现在可能有点事,晚一点吧.'},
    {sender: 4754815545700777984, context: '大佬,快救急啊.'},
    {sender: 4754815545700777984, context: '快,回话'},
    {sender: 4754815493586550784, context: '怎么了?小竹在呢'},
    {sender: 4755869713303601152, context: '怎么这么急?'},
    {sender: 4754815545700777984, context: '我老婆快生了,刚才说肚子疼,咋整?'},
    {sender: 4754815493586550784, context: '您不要着急,我这里可以马上安排车过去接您?手续一并给您办理齐全!'},
    {sender: 4755869713303601152, context: '赶快打120啊'},
    {sender: 4754815545700777984, context: '好的,好的,我的手机号是:13825641257,打我电话'},
    {sender: 4754815493586550784, context: '好的,小竹马上安排,已经有工作人员致电您的电话了.'},
    {sender: 4755869713303601152, context: '这么快?'},
    {sender: 4754815545700777984, context: '好的.'},
    {sender: 4754815493586550784, context: '手续全都办好了?只等交钱?'},
    {sender: 4755869593623330816, context: '昨天吃了辣的,今天一直跑肚,屁股火辣辣的疼,小竹咋回事!'},
    {sender: 4754815493586550784, context: '小竹可能刚在安排手续'},
    {sender: 4754815493586550784, context: '你这是吃啥了.'},
    {sender: 4755869593623330816, context: '我就是吃了几小捆辣椒!'},
    {sender: 4755869713303601152, context: '小竹,在呢,您这个情况应该是肠胃反应导致的!'},
    {sender: 4754815545700777984, context: '小竹,谢谢你,车已经到了楼下了,真快,工作人员已经抬我妻子下去了!'},
    {sender: 4755869593623330816, context: '生孩子这么快就安排到?'},
    {sender: 4754815493586550784, context: '是的,这个是社区服务,咱们都是附近居民,很快的,嘿嘿!'},
    {sender: 4755869713303601152, context: '是的呢,还有人有问题可以咨询,小竹!'},
  ],
  //4766412892943695872
  jiaDialog2: [
    {sender: 4754815493586550784, context: '来问一下这个抖音交流,都交流啥'},
    {sender: 4755869713303601152, context: '你好,就是交流如何抖音赚钱的'},
    {sender: 4754815493586550784, context: '哦,了解了'},
    {sender: 4755869713303601152, context: '嗯,抖音赚钱有很多种方式,看您主要了解哪种了.'},
    {sender: 4755869713303601152, context: '大家都相互交流呗!'},
    {sender: 4754815493586550784, context: '怎么成为抖音网红?'},
    {sender: 4754815493586550784, context: '我比较好奇这个'},
    {sender: 4754815545700777984, context: '请你脱衣,请你自残,请你作死!哈哈!'},
    {sender: 4754815545700777984, context: '不知贤兄能否接受?'},
    {sender: 4754815493586550784, context: '接受你MMMP啊,我想好好活着!'},
    {sender: 4755869713303601152, context: '……'},
    {sender: 4754815545700777984, context: '开玩笑的,那个网红都要有资源的,群里有资料,你可以简单看一下!'},
    {sender: 4754815493586550784, context: '是么?'},
    {sender: 4755869713303601152, context: '是的,你可以看一下!'},
    {sender: 4754815545700777984, context: '我其实看完了,学了,好像不管用的.'},
    {sender: 4754815493586550784, context: '我看一下,也想抖音赚钱'},
    {sender: 4755869713303601152, context: '如果你自己有好的方式也可以分享的'},
    {sender: 4754815545700777984, context: '我的方式就是恶搞,没别的'},
    {sender: 4754815493586550784, context: '恶搞也是一个路子啊.'},
    {sender: 4755869593623330816, context: '恶搞?有点俗啊,现在国家视频管控很严,我是靠搞笑吸睛的.'},
    {sender: 4754815493586550784, context: '对,对.'},
    {sender: 4754815493586550784, context: '搞笑也很不错'},
    {sender: 4755869593623330816, context: '是的,但是让人笑很难的,段子手很累的.'},
    {sender: 4755869713303601152, context: '你是专门找人写的,还是自己排练的?'},
    {sender: 4754815545700777984, context: '对啊'},
    {sender: 4755869593623330816, context: '我自己琢磨的,找别人不得给钱啊,给不起!'},
    {sender: 4754815493586550784, context: '也是.'},
    {sender: 4755869713303601152, context: '你们聊,我先撤了!'},
  ],
  //4766410686395858944
  jiaDialog3: [
    {sender: 4754815493586550784, context: '群内最近有啥单子没?'},
    {sender: 4755869713303601152, context: '有啊,淘宝,京东,天猫都有的'},
    {sender: 4754815493586550784, context: '多少钱?'},
    {sender: 4755869713303601152, context: '你看你要做多少量了!'},
    {sender: 4755869713303601152, context: '你现在一天非同IP能做多少?'},
    {sender: 4754815493586550784, context: '我可以做到一天1000的单量'},
    {sender: 4754815493586550784, context: '可以么?'},
    {sender: 4754815545700777984, context: '哇,算是个大手了.'},
    {sender: 4754815545700777984, context: '一天1000的'},
    {sender: 4754815493586550784, context: '不算,不算大手.'},
    {sender: 4755869713303601152, context: '已经算大手了,你接哪个都可以么?>'},
    {sender: 4754815545700777984, context: '我只能做100,一天'},
    {sender: 4754815493586550784, context: '我想做京东的'},
    {sender: 4755869713303601152, context: '可以,我这里发给你规则'},
    {sender: 4754815545700777984, context: '100的让做么?'},
    {sender: 4754815493586550784, context: '好的.'},
    {sender: 4755869713303601152, context: '1.非同IP 2.一单50 3.每100单结算一次,当日结.4.提供支付宝账号(其他不接受)'},
    {sender: 4754815545700777984, context: '100的让做么?'},
    {sender: 4754815493586550784, context: '好的知道了,发链接给我把.'},
    {sender: 4755869593623330816, context: '有拼多多的单子没?'},
    {sender: 4754815493586550784, context: '链接私聊发我把.'},
    {sender: 4754815493586550784, context: '好的,我收到了.'},
    {sender: 4755869593623330816, context: '群主在么?'},
    {sender: 4755869713303601152, context: '在的,拼多多目前没有单子.100的暂时比较少,有的话叫你.群内多关注!'},
    {sender: 4754815545700777984, context: '好的.'},
    {sender: 4755869593623330816, context: '明白了.'},
    {sender: 4754815493586550784, context: '好,那我开始刷单了哈.'},
    {sender: 4755869713303601152, context: '好的,我这里开数据统计.'},
  ],
  //4766409361738186752
  jiaDialog4: [
    {sender: 4754815493586550784, context: '最近大家有看什么小说么?'},
    {sender: 4755869713303601152, context: '我最近在看南派三叔的'},
    {sender: 4754815493586550784, context: '盗墓笔记?'},
    {sender: 4755869713303601152, context: '是的,比较老了!'},
    {sender: 4755869713303601152, context: '但是我爱看.'},
    {sender: 4754815493586550784, context: '哦,有谁能推荐几本新的么?'},
    {sender: 4754815493586550784, context: '玄幻的.'},
    {sender: 4754815545700777984, context: '斗破苍穹,大主宰,遮天'},
    {sender: 4754815545700777984, context: '蛮荒记,绝世武神.'},
    {sender: 4754815493586550784, context: '这些我都看了.'},
    {sender: 4755869713303601152, context: '我去,你这么牛?都看完了?'},
    {sender: 4754815545700777984, context: '是啊,我比较喜欢唐家三少的.'},
    {sender: 4754815493586550784, context: '我也喜欢.'},
    {sender: 4755869713303601152, context: '永夜君王呢?'},
    {sender: 4754815545700777984, context: '那是谁写的?'},
    {sender: 4754815493586550784, context: '是啊.'},
    {sender: 4755869713303601152, context: '烟雨江南啊.'},
    {sender: 4754815545700777984, context: '哦.知道了.'},
    {sender: 4754815493586550784, context: '好看么?'},
    {sender: 4755869593623330816, context: '我看了那个.'},
    {sender: 4754815493586550784, context: '如何?'},
    {sender: 4754815493586550784, context: '简述下.'},
    {sender: 4755869593623330816, context: '千夜自困苦中崛起，在背叛中坠落。自此一人一把枪行在永夜与黎明间却走出一段传奇。若永夜注定是他命运，那他也要成为主宰的王。'},
    {sender: 4755869713303601152, context: '又是成王的啊.'},
    {sender: 4754815545700777984, context: '你发出来了,我就不发了.就是这个.'},
    {sender: 4755869593623330816, context: '嗯.'},
    {sender: 4754815493586550784, context: '我去看看.'},
    {sender: 4755869713303601152, context: '我也是.'},
  ],
  //4766408516955029504
  jiaDialog5: [
    {sender: 4754815493586550784, context: '“当你无比的无聊的时候你会做什么？”'},
    {sender: 4755869713303601152, context: '“不知道，大概太无聊了，懒得思考吧”'},
    {sender: 4754815493586550784, context: '“可是太无聊了，一点事儿都没得做，真的很痛苦哎”'},
    {sender: 4755869713303601152, context: '“是呀，于是我就想着，会不会发生点什么不一样的，于是就等呀等。。。”'},
    {sender: 4755869713303601152, context: '“然后呢，发生什么了吗？”'},
    {sender: 4754815493586550784, context: '“什么也没有，还是一样的无聊。”'},
    {sender: 4754815493586550784, context: '“那你说什么说啊，一点用都没有，无聊。”'},
    {sender: 4754815545700777984, context: '“就是因为无聊才说的嘛，你不是也因为无聊才来找我说话的吗。”'},
    {sender: 4754815545700777984, context: '“是啊，可是还是很无聊，能做点什么不无聊的事吗”'},
    {sender: 4754815493586550784, context: '“啥事不无聊啊”'},
    {sender: 4755869713303601152, context: '“不知道，大概是有意义的事？”'},
    {sender: 4754815545700777984, context: '“哼！有意义，什么事有意义？”'},
    {sender: 4754815493586550784, context: '“都说了我不知道嘛。”'},
    {sender: 4755869713303601152, context: '“算了，还是继续无聊吧，反正做啥都挺无聊的。”'},
    {sender: 4754815545700777984, context: '“啊~~~无聊的人生，无聊的对话，我可能是个傻瓜吧”'},
    {sender: 4754815493586550784, context: '“你说对了，你就是一个傻瓜，还是个无聊的傻瓜。”'},
    {sender: 4755869713303601152, context: '“哈哈哈....能跟我这个傻瓜讲话的人也聪明不到哪去，你不也是一个无聊的人吗”'},
    {sender: 4754815545700777984, context: '“是呀，无聊就无聊呗，反正也找不到啥来做。”'},
    {sender: 4754815493586550784, context: '“但是，你不会感到焦虑吗？因为没事做。”'},
    {sender: 4755869593623330816, context: '“啥意思？”'},
    {sender: 4754815493586550784, context: '“就是大家好像都在忙什么，大家都在做什么，但是你却无聊到不知道做什么。”'},
    {sender: 4754815493586550784, context: '“会呀！会心慌，生怕自己落后了，于是我也想找点事做，但我还是找不着自己想做什么，于是又开始无聊了起来。”'},
    {sender: 4755869593623330816, context: '“嗯.....你说，大家是不是都很清楚自己想要的是什么，然后每天才都有事做？”'},
    {sender: 4755869713303601152, context: '“大概吧，不过做了之后才知道自己想做啥的人好像也有呢”'},
    {sender: 4754815545700777984, context: '“啊，好烦呐，为什么我们要烦恼自己想要做什么呢？”'},
    {sender: 4755869593623330816, context: '“不知道呐，人生嘛，活着，总要做点什么吧，不然就不算是活着了吧，大概，我想是这样的。”'},
    {sender: 4754815493586550784, context: '“是吗.....”'},
    {sender: 4755869713303601152, context: '“不过，什么都不做的人生也没什么不好的吧，只是什么都没做而已”'},
    {sender: 4754815493586550784, context: '“可是，不会感到不甘心吗，或者说有些后悔。”'},
    {sender: 4755869713303601152, context: '“谁知道，这我得到死的那一天才知道，再说了，我真的做了啥也不能保证死的时候就一定会满足的啊，就算不甘心又怎样，难道能选择不死？”'},
    {sender: 4754815545700777984, context: '“.....感觉你说的莫名的沉重呢，嘛，还是有道理的，人挺难说清楚的。”'},
    {sender: 4754815493586550784, context: '“唉，我也是想做点什么的，只是还没想好而已，太高的目标够不着，太低的不想做，说到底也就是个普通人。”'},
    {sender: 4755869713303601152, context: '“我也是，感觉自己没什么特长，也没什么天赋，能干什么呢....”'},
    {sender: 4754815545700777984, context: '“......”'},
    {sender: 4754815493586550784, context: '“你说，为什么，有的人有天赋，有的人没有呢？”'},
    {sender: 4755869713303601152, context: '“还真是复杂的问题啊，我又怎么会知道呢，既然是天赋的话，那就问老天吧”'},
    {sender: 4754815545700777984, context: '“哈，问天啊，要是天会回答就好了。不过呢，我想了一下，要是人人都有天赋的话，那就不是天赋了吧，就好像如果人人都是好人的话，就不会存在坏人这个对立面了吧，总要有普通的人才能衬托出有天赋的人吧！”'},
    {sender: 4754815493586550784, context: '“还挺有道理的，但是，好像没什么用啊，即使知道。”'},
    {sender: 4755869593623330816, context: '“是啊，没什么用，总之，努力吧，反正闲着也是闲着。”'},
    {sender: 4754815493586550784, context: '“无聊啊”'},
    {sender: 4755869593623330816, context: '“是啊，无聊。”'},
  ],
  //4766404519938506752
  jiaDialog6: [
    {sender: 4754815493586550784, context: '那个MR被打了!真的假的?'},
    {sender: 4755869713303601152, context: '半真半假!'},
    {sender: 4754815493586550784, context: '啥?'},
    {sender: 4755869713303601152, context: '她自己发的,有说她闹宝强的.'},
    {sender: 4755869713303601152, context: '也有说宝强是母亲被气昏了,王宝强才发飙了.'},
    {sender: 4754815493586550784, context: '不过MR被打我很爽啊.'},
    {sender: 4754815493586550784, context: '那个婊子,真的欠揍!'},
    {sender: 4754815545700777984, context: '你这人,明明是女人,就不能温柔一点么?哈哈.'},
    {sender: 4754815545700777984, context: '你懂得,"温柔"'},
    {sender: 4754815493586550784, context: '我只知道两横一竖.哇哈哈.'},
    {sender: 4755869713303601152, context: '你是一个淫贼!'},
    {sender: 4754815545700777984, context: '对,对,对,淫贼.'},
    {sender: 4754815493586550784, context: '人之初,性本恶,你们不知道?'},
    {sender: 4755869713303601152, context: '……'},
    {sender: 4754815545700777984, context: '不知道范爷能不能再出来了.'},
    {sender: 4754815493586550784, context: '她啊,在里面还没伺候好大爷,怎么出来?'},
    {sender: 4755869713303601152, context: '你们真的是,就不能盼人家点好呢?'},
    {sender: 4754815545700777984, context: '这话说的,难道范爷不是你意淫对象?'},
    {sender: 4754815493586550784, context: '嗯嗯,是我的.'},
    {sender: 4755869593623330816, context: '都是男人,何必装纯.哈哈.'},
    {sender: 4754815493586550784, context: '对,尽情释放,反正这辈子你是享受不到了!'},
    {sender: 4754815493586550784, context: '放肆起来!!!!!!!!!!!!'},
    {sender: 4755869593623330816, context: '不过范爷成了当头炮,比较惨啊,这娱乐圈啊,太黑暗,浑浊.'},
    {sender: 4755869713303601152, context: '却是,我等屁民也就能议论一下了,8亿啊,我几百年啊~~!'},
    {sender: 4754815545700777984, context: '你好好活着!'},
    {sender: 4755869593623330816, context: '对啊,老怪物!!!!!!!!!!!嘿嘿.'},
    {sender: 4754815493586550784, context: '闪人了,你们聊吧.'},
    {sender: 4755869713303601152, context: '我也闪了,一群淫贼!'},
  ],
  //4766415720642789376
  jiaDialog7: [
    {sender: 4754815493586550784, context: '昨天领养了一直小猫'},
    {sender: 4755869713303601152, context: '可耐么?'},
    {sender: 4754815493586550784, context: '超级可爱啊!'},
    {sender: 4755869713303601152, context: '可以让大家看看不?'},
    {sender: 4755869713303601152, context: '发出来?'},
    {sender: 4754815493586550784, context: '这个暂时好像发不了图片,后面可以我就发出来哈.'},
    {sender: 4754815493586550784, context: '真的很可爱.'},
    {sender: 4754815545700777984, context: '我女票也养了一只.'},
    {sender: 4754815545700777984, context: '天天的缠着我,我女票都生气了.哈哈.'},
    {sender: 4754815493586550784, context: '哈哈,猫小三啊!'},
    {sender: 4755869713303601152, context: '确实,猫很粘人的.'},
    {sender: 4754815545700777984, context: '嗯'},
    {sender: 4754815493586550784, context: '嗯'},
    {sender: 4755869713303601152, context: '不过橘猫就是个例外了,太大了.'},
    {sender: 4754815545700777984, context: '哈哈.'},
    {sender: 4754815493586550784, context: '不过小的时候很好玩啊.'},
    {sender: 4755869713303601152, context: '太懒了,就在那一趟.'},
    {sender: 4754815545700777984, context: '天天躺着是吧.'},
    {sender: 4754815493586550784, context: '人家是在养精蓄锐好不啦!'},
    {sender: 4755869593623330816, context: '波斯猫,到手了!'},
    {sender: 4754815493586550784, context: '眼睛好看不?'},
    {sender: 4754815493586550784, context: '什么颜色的?'},
    {sender: 4755869593623330816, context: '一个蓝的,一个黄的.'},
    {sender: 4755869713303601152, context: '橘猫还很能吃的.'},
    {sender: 4754815545700777984, context: '波斯猫很贵吧.'},
    {sender: 4755869593623330816, context: '我那个别人给的.'},
    {sender: 4754815493586550784, context: '哦.'},
    {sender: 4755869713303601152, context: '……'},
  ],
  //4766416574410145792
  jiaDialog8: [
    {sender: 4754815493586550784, context: '群主,你卖的只有你订单的几个课程么?'},
    {sender: 4755869713303601152, context: '不是啊,还有很多,这个只是用这个代表.'},
    {sender: 4754815493586550784, context: '哦.'},
    {sender: 4755869713303601152, context: '截图,你可以看一下,订单的,很多课程都有的.'},
    {sender: 4755869713303601152, context: '价格公平合理,都是专家级别的.信誉商家.'},
    {sender: 4754815493586550784, context: '我可以先买一个,试试看,可以再继续么?'},
    {sender: 4754815493586550784, context: '价格可以稍微便宜点不?'},
    {sender: 4754815545700777984, context: '我买了,还算可以吧.'},
    {sender: 4754815545700777984, context: '看个人了.'},
    {sender: 4754815493586550784, context: '你买的是课程几啊?'},
    {sender: 4755869713303601152, context: '可以的啊,不过价格是不能将的.'},
    {sender: 4754815545700777984, context: '我买了课程3,4,5'},
    {sender: 4754815493586550784, context: '哦.'},
    {sender: 4755869713303601152, context: '您可以群内问问大家是否可以.'},
    {sender: 4754815545700777984, context: '还不错'},
    {sender: 4754815493586550784, context: '我先接一单看看.'},
    {sender: 4755869713303601152, context: '好的.'},
    {sender: 4754815545700777984, context: '你们聊,我有事先走了.'},
    {sender: 4754815493586550784, context: '我接单了,你发火吧.'},
    {sender: 4755869593623330816, context: '群主,我也接了单了.'},
    {sender: 4754815493586550784, context: '群主?'},
    {sender: 4754815493586550784, context: '群主?'},
    {sender: 4755869593623330816, context: '估计在发送东西吧.'},
    {sender: 4755869713303601152, context: '在呢,不要急,东西我已经发送给你了,加微信传给你就好.'},
    {sender: 4754815493586550784, context: '好的呢.'},
    {sender: 4755869593623330816, context: '我也加么?'},
    {sender: 4754815493586550784, context: '加了.'},
    {sender: 4755869713303601152, context: '是的,都微信传给你们.'},
  ],
  //4766419515795849216
  jiaDialog9: [
    {sender: 4754815493586550784, context: '高端VIP群?'},
    {sender: 4755869713303601152, context: '是的,请说你的诉求,不闲聊,大家时间宝贵.'},
    {sender: 4754815493586550784, context: '我要参加名媛聚会,价格怎么算?'},
    {sender: 4755869713303601152, context: '您是想参加哪里的?参会的是否有对国籍,女性有特殊要求.'},
    {sender: 4755869713303601152, context: '接单之后,我将会私聊跟你继续后续对接资源内容.'},
    {sender: 4754815493586550784, context: '哦,好的'},
    {sender: 4754815493586550784, context: '我接单了.'},
    {sender: 4754815545700777984, context: '怎么个高端法?群主?'},
    {sender: 4754815545700777984, context: '能解释么?'},
    {sender: 4754815493586550784, context: '群主,我接单了,看到了没?已付款了.'},
    {sender: 4755869713303601152, context: '看到了,我私聊你资源给你,你的诉求也可以私聊跟我说.'},
    {sender: 4754815545700777984, context: '群主?'},
    {sender: 4754815493586550784, context: '好的,那我们私聊谈.'},
    {sender: 4755869713303601152, context: '好的,另外这位用户你好,区内禁止闲聊其他的,你不懂可以不接单,退群!谢谢.'},
    {sender: 4754815545700777984, context: '这么牛逼?不给解释?'},
    {sender: 4754815493586550784, context: '不是不给你解释,是不能这么明说,你相信就接单,钱也不是马上到他那,有平台担保的.'},
    {sender: 4755869713303601152, context: '楼上的用户说的很对,所以不解释！'},
    {sender: 4754815545700777984, context: '走就走，88888，装什么？'},
    {sender: 4754815493586550784, context: '。。。。。。'},
    {sender: 4755869593623330816, context: '群主，我看了，了解了，我接单了，我们直接私聊吧。'},
    {sender: 4754815493586550784, context: '好的。'},
    {sender: 4755869713303601152, context: '群内我先暂时停止对话，因为刚这2个客户我要去谈，怠慢大家多有抱歉！'},
    {sender: 4754766164410761216, context: '没事，理解'},
    {sender: 4754766164410761216, context: '没事，去吧。'},
    {sender: 4754766164410761216, context: '我先自己了解什么是名媛聚会，再来找你。'},
    {sender: 4755869713303601152, context: '好的。'},
    {sender: 4754766164410761216, context: '这个群很不错的！很直接不扯别的。'},
    {sender: 4755869713303601152, context: '谢谢支持！'},
  ],
  //4766420792827199488
  jiaDialog10: [
    {sender: 4754815493586550784, context: '群主，京东的通用打折卡有没有？'},
    {sender: 4755869713303601152, context: '有的，客官！'},
    {sender: 4754815493586550784, context: '多少钱？'},
    {sender: 4755869713303601152, context: '您要多大抵扣值的？'},
    {sender: 4755869713303601152, context: '多少张，订单上架的是否满足您？'},
    {sender: 4754815493586550784, context: '我要500的，500张。'},
    {sender: 4754815493586550784, context: '公司福利，发放的。'},
    {sender: 4754815545700777984, context: '群老大，100的淘宝361°李宁的代金券来50张，快。'},
    {sender: 4754815545700777984, context: '快，快。'},
    {sender: 4754815493586550784, context: '我这个跟你上架的不一样，要怎么接单？'},
    {sender: 4755869713303601152, context: '额，没问题的，爱着兄弟，已经给你了付款订单链接，你接单就好。'},
    {sender: 4754815545700777984, context: '额，好的。'},
    {sender: 4754815493586550784, context: '我呢？'},
    {sender: 4755869713303601152, context: '这位客官，目前官方没有上架多个的功能，价格都是发布时候定死的。'},
    {sender: 4754815545700777984, context: '您看，您接这个单，之后差价您加微信转给我，或者这个单您接够价格额也可。'},
    {sender: 4754815493586550784, context: '什么意思？'},
    {sender: 4755869713303601152, context: '您要购买500的，数量没问题，价格给你优惠448，不二价，之后这个价格你接这个单只要金额够就可以。'},
    {sender: 4754815545700777984, context: '群老大，接单了，付款了，快点完成，给我东西，快递给我就好。'},
    {sender: 4755869713303601152, context: '好的，收到了。'},
    {sender: 4755869593623330816, context: '那个，天猫的50的，我要200张。'},
    {sender: 4754815493586550784, context: '哦，明白了，可以。那我算一下，之后接单。'},
    {sender: 4755869713303601152, context: '嗯，嗯，好的。哎呦喂，我连接发给你。'},
    {sender: 4754766164410761216, context: '天猫的100的，来300张'},
    {sender: 4754766164410761216, context: '沃尔玛的200块的，来800张。'},
    {sender: 4754766164410761216, context: '京东超时的代金券，来80张。'},
    {sender: 4755869713303601152, context: '好的，稍等，店小二马上给诸位客官发链接哈。'},
    {sender: 4754815493586550784, context: '群主，我接单了，价格算好了你看下看到没。'},
    {sender: 4755869713303601152, context: '好的，看到了，我马上顺风快递给您！'},
    {sender: 4754766164410761216, context: '已付款'},
    {sender: 4754766164410761216, context: '已付款'},
    {sender: 4754766164410761216, context: '已付款'},
    {sender: 4755869713303601152, context: 'OK，马上发货！'},

  ],
  //4766422915660922880
  jiaDialog11: [
    {sender: 4754815493586550784, context: '欢迎加入的小伙伴！'},
    {sender: 4755869713303601152, context: '请问，这个羽毛球需要收费么？'},
    {sender: 4755869593623330816, context: '我刚来弱弱的问一下，这个羽毛球怎么一起打？收费？免费？'},
    {sender: 4754815493586550784, context: '小伙伴们，我们这个是自愿行为，收费是给场地的，大家A制的。'},
    {sender: 4755869713303601152, context: '哦，原来是这样的啊！'},
    {sender: 4754815493586550784, context: '是的呢！'},
    {sender: 4755869713303601152, context: '美女，男的你们有要求什么条件么？'},
    {sender: 4755869593623330816, context: '我也是女哒，哈哈！'},
    {sender: 4754815493586550784, context: '没有条件，只要来打就好。'},
    {sender: 4754815493586550784, context: '欢迎美女，嘻嘻！'},
    {sender: 4755869593623330816, context: '那个，我这里有3个人唉！'},
    {sender: 4755869713303601152, context: '我这里就我1个'},
    {sender: 4755869713303601152, context: '要不美女我们凑凑？'},
    {sender: 4754815493586550784, context: '都可以啊，大家加入都是爱好羽毛球的，想打的时候这里喊一句，有打的就一起啊！'},
    {sender: 4755869593623330816, context: '可以啊，帅哥哥！'},
    {sender: 4754815493586550784, context: '嘿嘿！'},
    {sender: 4757228901845958656, context: '新人报道，多多关照！'},
    {sender: 4754815493586550784, context: '欢迎新人！'},
    {sender: 4757228901845958656, context: '刚来不知道规矩，群猪讲一下！'},
    {sender: 4754815493586550784, context: '你才是猪！哼！'},
    {sender: 4755869593623330816, context: '哈哈！'},
    {sender: 4755869713303601152, context: '哈哈！'},
    {sender: 4754815493586550784, context: '那个，这里就是大家喜欢羽毛球的，可以这里找人一起打，费用AA制，自由发挥，给的是场地费就可以了！'},
    {sender: 4755869593623330816, context: '这个群我很喜欢，很不错呢！'},
    {sender: 4757228901845958656, context: '哦，原来如此！了解了！'},
    {sender: 4754815493586550784, context: '嗯，嗯。'},
    {sender: 4754815493586550784, context: '谢谢美女的喜欢！'},
  ],
  //4767483364607279104
  jiaDialog12: [
    {sender: 4754815493586550784, context: '群主，送东西了。'},
    {sender: 4755869713303601152, context: '在的呢，亲。'},
    {sender: 4754815493586550784, context: '赶紧送一套海鲜大套餐过来。'},
    {sender: 4755869713303601152, context: '好的呢。'},
    {sender: 4755869713303601152, context: '请发地址。'},
    {sender: 4754815493586550784, context: '我私聊发你哈。'},
    {sender: 4754815493586550784, context: '你看一下。'},
    {sender: 4755869593623330816, context: '我订一套火锅菜系就行了。'},
    {sender: 4755869593623330816, context: '地址我私聊发你了。'},
    {sender: 4754815493586550784, context: '你看了没？'},
    {sender: 4755869713303601152, context: '您好，我已经受到了都，马上安排人员配送。'},
    {sender: 4755869593623330816, context: '嗯。'},
    {sender: 4754815493586550784, context: '好的。'},
    {sender: 4755869713303601152, context: '还有什么需要帮助的么？'},
    {sender: 4755869593623330816, context: '不用了。'},
    {sender: 4754815493586550784, context: '不用了。'},
    {sender: 4755869713303601152, context: '好的。'},
    {sender: 4755869593623330816, context: '嗯，谢谢，快点哈。'},
    {sender: 4755869713303601152, context: '嗯，很快就到。'},
    {sender: 4757228901845958656, context: '那个，我问一下你们这个怎么个送法。'},
    {sender: 4754815493586550784, context: '那我等着了。'},
    {sender: 4755869713303601152, context: '就是您群里说需要什么，私聊发地址，我安排人员下单给你送货上门。'},
    {sender: 4754815493586550784, context: '哦，懂了。'},
    {sender: 4755869713303601152, context: '给我来一套家常菜套餐，要A套餐。'},
    {sender: 4755869593623330816, context: '给我来一个B套餐。'},
    {sender: 4755869713303601152, context: '好的呢，私聊发给我地址。'},
    {sender: 4754815493586550784, context: '我看到了，很快，群主果然66666666666'},
    {sender: 4755869713303601152, context: '嗯，好的。'},
    {sender: 4754815493586550784, context: '那给我来一套生鲜的套餐吧。多少钱？'},
    {sender: 4755869713303601152, context: '我发你地址了。'},
    {sender: 4755869593623330816, context: '我也是。'},
    {sender: 4755869713303601152, context: '收到了。'},
  ],
  //4767485097806938112
  jiaDialog13: [
    {sender: 4754815493586550784, context: '有人么？'},
    {sender: 4755869713303601152, context: '有的，你是第一个进来的吃货'},
    {sender: 4754815493586550784, context: '哈哈，这个群怎么个玩法呢？'},
    {sender: 4755869713303601152, context: '就是大家有发现好吃的地方，把秘密地点公布出来，让群内的都知道！'},
    {sender: 4755869593623330816, context: '我来了，吃货们！'},
    {sender: 4755869593623330816, context: '群主，我是新人吃货一枚！'},
    {sender: 4755869713303601152, context: '哈哈，你好，看来吃货越来越多了！'},
    {sender: 4754815493586550784, context: '是啊，我们爆照吧！哇哈哈！'},
    {sender: 4755869713303601152, context: '这个大家随意了，我无所谓，我是男的！'},
    {sender: 4755869593623330816, context: '你这样很不好的呢！'},
    {sender: 4755869713303601152, context: '一看你就是个美女，说话总是酱紫，酱紫的。'},
    {sender: 4757228901845958656, context: '问一下，这个群是干啥的？'},
    {sender: 4755869713303601152, context: '是吃喝社群，大家发现好吃的一起去吃喝！'},
    {sender: 4757228901845958656, context: '哦！'},
    {sender: 4755869713303601152, context: '嗯。'},
    {sender: 4754815493586550784, context: '费用，群主咋算！'},
    {sender: 4755869593623330816, context: '对啊！咋算的！'},
    {sender: 4755869713303601152, context: '这个可以自己单独去啊，只要提供地点就好了，也可以群员组队去，AA制吧，公平合理的！'},
    {sender: 4757228901845958656, context: '不错，不错，很不错！'},
    {sender: 4757228901845958656, context: '这个我喜欢！'},
    {sender: 4757228901845958656, context: '你们有什么好地方推荐么？'},
    {sender: 4755869713303601152, context: '我个人喜欢城东的辣妹子火锅，肉很不错的，辣的够劲，辣的过瘾！'},
    {sender: 4754815493586550784, context: '啥？我不喜欢啦，我喜欢吃广东菜系的！'},
    {sender: 4755869593623330816, context: '我喜欢的是东北菜！'},
    {sender: 4755844628043792384, context: '刚进来就看到一个跟我喜欢一样菜系的人，我也是广东菜系的！'},
    {sender: 4755869713303601152, context: '东北菜？你是东北的？'},
    {sender: 4755844628043792384, context: '我不是东北的，我是湖南的，但是喜欢广东菜！'},
    {sender: 4755869713303601152, context: '没，我问楼上那个喜欢东北菜的人。'},
    {sender: 4754815493586550784, context: '喜欢东北菜，不一定是东北人啊！'},
    {sender: 4757228901845958656, context: '我也想尝尝东北菜了！'},
    {sender: 4755869593623330816, context: '东北菜可很实惠的！'},
    {sender: 4755869713303601152, context: '可是我觉得，菜都很咸啊！'},
    {sender: 4755844628043792384, context: '淡一点的，东北菜挺好吃的！'},
    {sender: 4755844628043792384, context: '我吃过，不错的！'},
    {sender: 4755869713303601152, context: '是么？'},
    {sender: 4755844628043792384, context: '嗯'},
    {sender: 4755869713303601152, context: '看了半天原来是吃货讨论群啊'},
    {sender: 4755869713303601152, context: '算是，主要是提供给大家好吃的地方的社群！'},
    {sender: 4755869713303601152, context: '哦，明白了，去不去随意是吧！'},
    {sender: 4755869713303601152, context: '对头！'},
    {sender: 4755869593623330816, context: '东北菜提供一个地方呗？实惠点的！'},
    {sender: 4755844628043792384, context: '往来东北，那家不错！'},
    {sender: 4755869713303601152, context: '改天去吃去一下！'},
    {sender: 4755869713303601152, context: '你们继续聊吧，我先撤了，有点事！'},
],
  //4767486040195743744
  jiaDialog14: [
    {sender: 4754815493586550784, context: '群主，京东的通用打折卡有没有？'},
    {sender: 4755869713303601152, context: '有的，客官！'},
    {sender: 4754815493586550784, context: '多少钱？'},
    {sender: 4755869713303601152, context: '您要多大抵扣值的？'},
    {sender: 4755869713303601152, context: '多少张，订单上架的是否满足您？'},
    {sender: 4754815493586550784, context: '我要500的，500张。'},
    {sender: 4754815493586550784, context: '公司福利，发放的。'},
    {sender: 4755869593623330816, context: '群老大，100的淘宝361°李宁的代金券来50张，快。'},
    {sender: 4755869593623330816, context: '快，快。'},
    {sender: 4754815493586550784, context: '我这个跟你上架的不一样，要怎么接单？'},
    {sender: 4755869713303601152, context: '额，没问题的，爱着兄弟，已经给你了付款订单链接，你接单就好。'},
    {sender: 4755869593623330816, context: '额，好的。'},
    {sender: 4754815493586550784, context: '我呢？'},
    {sender: 4755869713303601152, context: '这位客官，目前官方没有上架多个的功能，价格都是发布时候定死的。'},
    {sender: 4755869593623330816, context: '您看，您接这个单，之后差价您加微信转给我，或者这个单您接够价格额也可。'},
    {sender: 4754815493586550784, context: '什么意思？'},
    {sender: 4755869713303601152, context: '您要购买500的，数量没问题，价格给你优惠448，不二价，之后这个价格你接这个单只要金额够就可以。'},
    {sender: 4755869593623330816, context: '群老大，接单了，付款了，快点完成，给我东西，快递给我就好。'},
    {sender: 4755869713303601152, context: '好的，收到了。'},
    {sender: 4757228901845958656, context: '那个，天猫的50的，我要200张。'},
    {sender: 4754815493586550784, context: '哦，明白了，可以。那我算一下，之后接单。'},
    {sender: 4755869713303601152, context: '嗯，嗯，好的。哎呦喂，我连接发给你。'},
    {sender:4754815493586550784, context: '天猫的100的，来300张'},
    {sender: 4755844628043792384, context: '沃尔玛的200块的，来800张。'},
    {sender: 4755869713303601152, context: '京东超时的代金券，来80张。'},
    {sender: 4755869713303601152, context: '好的，稍等，店小二马上给诸位客官发链接哈。'},
    {sender: 4754815493586550784, context: '群主，我接单了，价格算好了你看下看到没。'},
    {sender: 4755869713303601152, context: '好的，看到了，我马上顺风快递给您！'},
    {sender:4754815493586550784, context: '已付款'},
    {sender: 4755844628043792384, context: '已付款'},
    {sender: 4755869713303601152, context: '已付款'},
    {sender: 4755869713303601152, context: 'OK，马上发货！'},
    ],
  //4768238223879061504
  jiaDialog15: [
    {sender: 4754815493586550784, context: '你们超时刚开？'},
    {sender: 4755869713303601152, context: '是的。'},
    {sender: 4754815493586550784, context: '东西打折？'},
    {sender: 4755869713303601152, context: '对的，多买多送。'},
    {sender: 4755869713303601152, context: '充会员卡永久免费享受三公里送货。'},
    {sender: 4754815493586550784, context: '是么？'},
    {sender: 4754815493586550784, context: '挺好。'},
    {sender: 4755869593623330816, context: '我离你们不远，可以考虑。'},
    {sender: 4755869593623330816, context: '我先过去看看。'},
    {sender: 4754815493586550784, context: '我也先看看去。'},
    {sender: 4755869713303601152, context: '嗯，嗯，地理位置就是地图上的位置哈。'},
    {sender: 4755869593623330816, context: '好的。'},
    {sender: 4754815493586550784, context: '好的。'},
    {sender: 4755869713303601152, context: '嗯。'},
    {sender: 4755869593623330816, context: '一会到了再说哈。'},
    {sender: 4754815493586550784, context: '出门了哈。'},
    {sender: 4755869713303601152, context: '嗯，好的呢，感谢您的光临。'},
    {sender: 4755869593623330816, context: '嘿嘿。'},
    {sender: 4755869713303601152, context: '嗯。'},
    {sender: 4757228901845958656, context: '首冲要多少？'},
    {sender: 4754815493586550784, context: '先不聊了，过去你们那里了。'},
    {sender: 4755869713303601152, context: '嗯。'},
    {sender: 4754815493586550784, context: '几折啊？'},
    {sender: 4754815493586550784, context: '说话啊。'},
    {sender: 4757228901845958656, context: '3公里免费送？永久？'},
    {sender: 4755869713303601152, context: '是的，首冲5000，永久3公里免费送货。'},
    {sender: 4754815493586550784, context: '你们可以先去看看。'},
    {sender: 4755869713303601152, context: '嗯，对的，看到了好，才是真的好。'},
    {sender: 4754815493586550784, context: '好吧。'},
    {sender: 4754815493586550784, context: '好吧。考虑一下。'},
    {sender: 4757228901845958656, context: '我也是。'},
    {sender: 4755869713303601152, context: '嗯，嗯，好的。'},
  ],
//4758366710279454720年检帮忙
};

JiaShuJu.install = function (Vue, options) {
  Vue.prototype.$jiashuju = JiaShuJu
};

export default JiaShuJu



// WEBPACK FOOTER //
// ./src/plugins/jiashuju.js